export default __webpack_public_path__ + "static/media/bg-tablet.922a48f8.jpg";